import {Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NotificationSubscription, NotifyMessage, NotificationService} from "../../..";
import {BehaviorSubject} from "rxjs";
import {CdkDragDrop} from "@angular/cdk/drag-drop";

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.css'],
  standalone: false,
})

export class SendNotificationComponent implements OnInit {

  public message$: BehaviorSubject<string | null> = new BehaviorSubject(null);
  public showMsg = false;
  public isErr = false;

  notifyMessage: NotifyMessage;
  notifyForm: FormGroup = this.fb.group({
    title: [{ value: '', disabled: false }, [Validators.required]],
    content: [{ value: '', disabled: false }, [Validators.required]],
    openURL: [{ value: '', disabled: false }],
    actions: this.fb.array([])
  });

  actionsGroup: FormGroup = this.fb.group({
    title: [{ value: '', disabled: false }, [Validators.required]],
    action: [{ value: '', disabled: false }, [Validators.required]],
    icon: [{ value: '', disabled: false }]
  });

  get actions(): FormArray {
    return this.notifyForm.get('actions') as FormArray;
  }

  constructor(private notifyServ: NotificationService, private fb: FormBuilder,public dialogRef: MatDialogRef<SendNotificationComponent>,
              @Inject(MAT_DIALOG_DATA) public data: NotifyMessage) {

    this.notifyForm = this.fb.group({
      title: [{ value: '', disabled: false }, [Validators.required]],
      content: [{ value: '', disabled: false }, [Validators.required]],
      openURL: [{ value: '', disabled: false }],
      actions: this.fb.array([])
    });

    this.actionsFormGroup();
  }

  ngOnInit(): void {
    console.log('dialogue subscriptions:',this.data.subscriptions);
    this.showMsg = false;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSendClick() {
    this.showMsg = false;
    const formValues = this.notifyForm.getRawValue();

    console.log('send form', formValues);
    let message = '';
    this.message$.next(message);

    this.notifyMessage = {
      subscriptions: this.data.subscriptions,
      content: formValues.content,
      title: formValues.title,
      openURL: formValues.openURL,
      actions: formValues.actions
    };

    this.notifyServ.sendNotification(this.notifyMessage).subscribe(
        response => {

          if (response.errors[0].code === 0) {
            this.isErr = false;
            message = 'Notification  Send';
          } else {
            this.isErr = true;
            message = JSON.stringify(response);
          }
          this.message$.next(message);
          this.showMsg = true;

        }
    );

    // this.dialogRef.close();

  }

  actionsFormGroup(): FormGroup {
    return this.fb.group({
      title: [{ value: '', disabled: false }, [Validators.required]],
      action: [{ value: '', disabled: false }, [Validators.required]],
      icon: [{ value: '', disabled: false }]
    });
  }


  removeActionButtonClick(i: number) {
    this.actions.removeAt(i);
  }

  addActionButtonClick() {
    this.actions.push(this.actionsFormGroup());
  }

  drop(event: CdkDragDrop<FormGroup[]>) {
    console.log(`currentIndex:${event.currentIndex}  previousIndex:${event.previousIndex}`);
    const dir = event.currentIndex > event.previousIndex ? 1 : -1;

    const from = event.previousIndex;
    const to = event.currentIndex;

    const temp = this.actions.at(from);
    for (let i = from; i * dir < to * dir; i = i + dir) {
      const current = this.actions.at(i + dir);
      this.actions.setControl(i, current);
    }
    this.actions.setControl(to, temp);
  }
}
